import { collection, type Timestamp } from "@doitintl/models-types";

@collection("functions")
export class FunctionModel {
  timestamp!: Timestamp;
}
